import React, {Component} from 'react';
import debounce from 'utils/debounce';

export default class Timeline extends Component {
  constructor(props) {
    super();

    this.pointHeight = 7;
    this.vertOffset = Number(props.vertOffset || 0);

    this.state = {
      'xCoords': [],
      'yCoords': [],
      'leftOffset': props.leftOffset || 0,
      'style': {},
    }

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.handleWindowResize = debounce(() => {
      this.calculateStyle();
    }, 100);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    this.calculateStyle();

    window.addEventListener('resize', this.handleWindowResize);
  }

  /**
   * React Lifecycle Hook
   * Invoked immediately after updating occurs. This method is not called
   * for the initial render. Use this as an opportunity to operate on the
   * DOM when the component has been updated.
   *
   * @method  componentDidUpdate
   */
  componentDidUpdate(prevProps, prevState) {
    this.insertPoints();
  }

  /**
   * React Lifecycle Hook
   * Invoked immediately before a component is unmounted and destroyed.
   * Perform any necessary cleanup in this method
   *
   * @method  componentWillUnmount
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  calculateStyle() {
    let xCoords = [];
    let yCoords = [];

    for (let el of document.querySelectorAll('.js-timeline-point')) {
      xCoords.push(el.offsetLeft);
      yCoords.push(el.offsetTop);
    }

    const top = Math.min(...yCoords);
    const bottom = Math.max(...yCoords);
    const rawLeft = Math.max(...xCoords);
    const left = this.determineLeft(rawLeft);

    this.setState({
      'xCoords': xCoords,
      'yCoords': yCoords,
      'style': {
        'height': bottom - top,
        'left': this.props.alwaysLeft ? '0' : left,
        'top': top + this.vertOffset + this.pointHeight,
      }
    });
  }

  determineLeft(rawLeft = 0) {
    if (!this.props.adjustForMobile || this.inMobileViewport()) {
      return '50%';
    } else {
      return rawLeft - this.state.leftOffset;
    }
  }

  insertPoints() {
    this.removeExistingPoints();

    if (this.state.style.height <= 0) return;

    this.state.yCoords.forEach(coord => {
      const point = document.createElement('span');
      const baseTop = coord - this.state.style.top + this.vertOffset;

      point.className = 'timeline-point';
      point.style.top = `${baseTop === 0 ? -this.pointHeight : baseTop}px`;

      this.timeline.appendChild(point);
    });
  }

  removeExistingPoints() {
    const el = this.timeline;

    while (el.firstChild) {
      el.removeChild(el.firstChild);
    }
  }

  inMobileViewport() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  render() {
    return(
      <span
        ref={timeline => {this.timeline = timeline}}
        className="timeline"
        style={this.state.style}
      ></span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/components/timeline/timeline.jsx